var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"other"},[_c('UserProfileCard',{attrs:{"initialUser":_vm.user}}),_c('UserTweetListCard',{attrs:{"initialUser":_vm.user},on:{"after-show-reply-modal":_vm.afterShowReplyModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }